module.exports = ".organization-selection-form .organization-selection-container .organization-selection-row:not(:last-child) {\n  margin-bottom: 10px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/partials/organization-selection-form/organization-selection-form.component.scss
// module id = ./src/app/partials/organization-selection-form/organization-selection-form.component.scss
// module chunks = main